import { requests, mainApiRoot } from './index'

export const Addons = {
  getAddons: () =>
    requests.get(mainApiRoot, '/addons'),
  getOwnedAddons: () =>
    // requests.get(mock, '/addons/owned.json'),
    requests.get(mainApiRoot, '/account/addons'),
  removeAddon: id => requests.del(mainApiRoot, `/cancel-addon/${id}`)
}
